import React from 'react';
import { PlusIcon, EyeIcon, EditIcon, TrashIcon, CheckCircleIcon } from 'lucide-react';
import type { TaxType } from './TaxTypeManagement';
export function TaxTypesList({
  globalTaxTypes,
  orgUnitTaxTypes,
  onAdd,
  onEdit,
  onDelete,
  locale = 'en-US'
}) {
  // Combine all tax types into a single list
  const allTaxTypes = [...globalTaxTypes, ...orgUnitTaxTypes];
  return <div className="bg-white shadow rounded-lg" data-id="element-12517">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200" data-id="element-12518">
        <div className="flex items-center justify-between" data-id="element-12519">
          <div data-id="element-12520">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-12521">
              Tax Types
            </h3>
            <p className="mt-1 text-sm text-gray-500" data-id="element-12522">
              Manage tax type definitions used across the organization
            </p>
          </div>
          <button onClick={onAdd} className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-12523">
            <PlusIcon className="h-4 w-4 mr-2" data-id="element-12524" />
            Add Tax Type
          </button>
        </div>
      </div>

      {allTaxTypes.length === 0 ? <div className="px-4 py-12 text-center" data-id="element-12525">
          <p className="text-sm text-gray-500" data-id="element-12526">No tax types configured.</p>
        </div> : <div className="overflow-x-auto" data-id="element-12527">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-12528">
            <thead className="bg-gray-50" data-id="element-12529">
              <tr data-id="element-12530">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12531">
                  Code
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12532">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12533">
                  Description
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12534">
                  Status
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12535">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-12536">
              {allTaxTypes.map(taxType => <tr key={taxType.id} className="hover:bg-gray-50" data-id="element-12537">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-12538">
                    {taxType.code}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-12539">
                    {taxType.name}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500" data-id="element-12540">
                    {taxType.description}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-12541">
                    {taxType.isActive ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-12542">
                        <CheckCircleIcon className="h-3 w-3 mr-1" data-id="element-12543" />
                        Active
                      </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-12544">
                        Inactive
                      </span>}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-12545">
                    <div className="flex justify-end space-x-3" data-id="element-12546">
                      <button onClick={() => onEdit(taxType)} className="text-indigo-600 hover:text-indigo-900" title="Edit" data-id="element-12547">
                        <EditIcon className="h-4 w-4" data-id="element-12548" />
                        <span className="sr-only" data-id="element-12549">Edit</span>
                      </button>
                      <button onClick={() => onDelete(taxType.id)} className="text-red-600 hover:text-red-900" title="Delete" data-id="element-12550">
                        <TrashIcon className="h-4 w-4" data-id="element-12551" />
                        <span className="sr-only" data-id="element-12552">Delete</span>
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>}
    </div>;
}